var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.handleClose,
            title: _vm.fromData.title,
            visible: _vm.dialogVisible,
            width: "680px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "body" }, [
            _c("div", { staticClass: "content" }, [
              _c("ul", { staticClass: "content-title" }, [
                _c("li", [
                  _c("p", { staticClass: "text-left" }, [
                    _vm._v(_vm._s(_vm.$t("file.spacemember"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "p",
                    [
                      _c(
                        "el-checkbox",
                        {
                          on: {
                            change: function ($event) {
                              return _vm.handleChange(1)
                            },
                          },
                          model: {
                            value: _vm.lookCheck,
                            callback: function ($$v) {
                              _vm.lookCheck = $$v
                            },
                            expression: "lookCheck",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("public.check")))]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    [
                      _c(
                        "el-checkbox",
                        {
                          on: {
                            change: function ($event) {
                              return _vm.handleChange(2)
                            },
                          },
                          model: {
                            value: _vm.createCheck,
                            callback: function ($$v) {
                              _vm.createCheck = $$v
                            },
                            expression: "createCheck",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("public.establish")))]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    [
                      _c(
                        "el-checkbox",
                        {
                          on: {
                            change: function ($event) {
                              return _vm.handleChange(3)
                            },
                          },
                          model: {
                            value: _vm.editCheck,
                            callback: function ($$v) {
                              _vm.editCheck = $$v
                            },
                            expression: "editCheck",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("public.edit")))]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    [
                      _c(
                        "el-checkbox",
                        {
                          on: {
                            change: function ($event) {
                              return _vm.handleChange(4)
                            },
                          },
                          model: {
                            value: _vm.downloadCheck,
                            callback: function ($$v) {
                              _vm.downloadCheck = $$v
                            },
                            expression: "downloadCheck",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("public.download")))]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    [
                      _c(
                        "el-checkbox",
                        {
                          on: {
                            change: function ($event) {
                              return _vm.handleChange(5)
                            },
                          },
                          model: {
                            value: _vm.deleteCheck,
                            callback: function ($$v) {
                              _vm.deleteCheck = $$v
                            },
                            expression: "deleteCheck",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("public.delete")))]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "content-body" },
                _vm._l(_vm.userList, function (item, index) {
                  return _c("li", { key: index }, [
                    _c("p", { staticClass: "username" }, [
                      _c("img", { attrs: { src: item.card.avatar, alt: "" } }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(item.card.name))]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "p",
                      [
                        _c("el-checkbox", {
                          attrs: { label: item.lookCheck },
                          model: {
                            value: item.lookCheck,
                            callback: function ($$v) {
                              _vm.$set(item, "lookCheck", $$v)
                            },
                            expression: "item.lookCheck",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      [
                        _c("el-checkbox", {
                          attrs: { label: item.createCheck },
                          model: {
                            value: item.createCheck,
                            callback: function ($$v) {
                              _vm.$set(item, "createCheck", $$v)
                            },
                            expression: "item.createCheck",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      [
                        _c("el-checkbox", {
                          attrs: { label: item.editCheck },
                          model: {
                            value: item.editCheck,
                            callback: function ($$v) {
                              _vm.$set(item, "editCheck", $$v)
                            },
                            expression: "item.editCheck",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      [
                        _c("el-checkbox", {
                          attrs: { label: item.downloadCheck },
                          model: {
                            value: item.downloadCheck,
                            callback: function ($$v) {
                              _vm.$set(item, "downloadCheck", $$v)
                            },
                            expression: "item.downloadCheck",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      [
                        _c("el-checkbox", {
                          attrs: { label: item.deleteCheck },
                          model: {
                            value: item.deleteCheck,
                            callback: function ($$v) {
                              _vm.$set(item, "deleteCheck", $$v)
                            },
                            expression: "item.deleteCheck",
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                }),
                0
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer text-right",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.handleClose } },
                [_vm._v(_vm._s(_vm.$t("public.cancel")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    loading: _vm.loading,
                    size: "small",
                    type: "primary",
                  },
                  on: { click: _vm.handleAdd },
                },
                [_vm._v(_vm._s(_vm.$t("public.ok")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }